// sublayout dashbordu - menu w sidebarze

import React, { FC, useCallback, useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { Grid } from '@mui/material';
import classnames from 'classnames';
import each from 'lodash/each';
import find from 'lodash/find';

import { useSelector } from 'store';
import { useAppNavigate } from 'hooks';
import { Container, Breadcrumbs } from 'components/controls';
import { DashboardMenu } from 'components/containers';

import styles from 'theme/components/layouts/DashboardSubLayout/SubLayoutDashboard.module.scss';

// typ danych wejściowych
interface IProps {
  urlPrefix: string;
}

interface IRoute {
  label: string;
  path: string;
  key: string | null;
}

export const userRolesAccessRoutes = () => ({
  ROLE_USER_MAIN: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [
      { label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' },
      { label: 'Zwroty i reklamacje', path: '/dashboard/returns-complaints', key: 'returns-complaints' },
    ],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_USER: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [
      { label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' },
      { label: 'Zwroty i reklamacje', path: '/dashboard/returns-complaints', key: 'returns-complaints' }],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_ADMIN: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [
      { label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' },
      { label: 'Zwroty i reklamacje', path: '/dashboard/returns-complaints', key: 'returns-complaints' }]
    ,
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_TRADER: {
    orders: [
      { label: 'Zamówienia', path: '/dashboard/orders', key: 'orders' },
      { label: 'Miejsca dostaw', path: '/dashboard/deliveries', key: 'deliveries' }
    ],
    carts: [
      { label: 'Lista koszyków', path: '/dashboard/carts', key: 'carts' },
      { label: 'Importuj koszyk', path: '/dashboard/carts/import', key: 'import' },
      { label: 'Listy zakupowe', path: '/dashboard/shopping-lists', key: 'shopping-lists' }
    ],
    payments: [{ label: 'Lista płatności', path: '/dashboard/payments', key: 'payments' }],
    offers: [
      { label: 'Dedykowane', path: '/dashboard/offers/dedicated', key: 'dedicated' },
      { label: 'Okresowe', path: '/dashboard/offers/periodic', key: 'periodic' },
      { label: 'Export danych', path: '/dashboard/export', key: 'export' }
    ],
    documents: [{ label: 'Dokumenty', path: '/dashboard/documents', key: 'documents' }],
    myData: [
      { label: 'Moje konto', path: '/dashboard/my-account', key: 'my-account' },
      { label: 'Zgody', path: '/dashboard/consent', key: 'consent' },
      { label: 'Regulamin', path: '/dashboard/terms', key: 'terms' }
    ],
    clients: [
      { label: 'Lista klientów', path: '/dashboard/clients', key: 'clients' },
      { label: 'Adresy dostaw', path: '/dashboard/receivers', key: 'receivers' }
    ],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [
      { label: 'Lista użytkowników', path: '/dashboard/users', key: 'users' },
      { label: 'Punkty odbioru', path: '/dashboard/receivers', key: 'receivers' }
    ],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  },
  ROLE_OPEN_PROFILE: {
    orders: [],
    carts: [],
    payments: [],
    offers: [],
    documents: [],
    myData: [],
    clients: [],
    catalog: [],
    search: [],
    marketing: [],
    users: [],
    myCompany: [],
    cms: [],
    gpsr: [],
    configuration: [],
    adminApi: [],
    system: []
  }
});

const SubLayoutDashboard: FC<IProps> = ({ urlPrefix }) => {
  const { profile } = useSelector((state) => state.auth);
  const navigate = useAppNavigate();

  // ścieżka z url
  const { pathname } = useLocation();

  // czy użytkownik ma dostęp do podstrony
  const allowRoute = useCallback(() => {
    let arr: IRoute[] = [{ label: 'Dashboard', path: '/dashboard', key: null }];

    each(
      userRolesAccessRoutes()[`${profile?.role || 'ROLE_OPEN_PROFILE'}`],
      (route) => (arr = [...arr, ...route])
    );

    return !!find(arr, (route) => route.key && pathname.includes(route.key));
  }, [pathname]);

  useEffect(() => {
    if (pathname === `${urlPrefix}/dashboard`) {
      return;
    }

    if (!allowRoute()) {
      navigate('/dashboard');
    }
  }, [pathname]);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Layouts-DashboardSubLayout'
      )}>
      <Container>
        <Breadcrumbs />
        <Grid container columnSpacing="32px">
          <Grid item md={2} xs={12} className={styles.menuWrapper}>
            {profile?.role && (
              <DashboardMenu accessRoutes={userRolesAccessRoutes()[`${profile.role}`]} />
            )}
          </Grid>
          <Grid item md={10} xs={12}>
            <Outlet />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default SubLayoutDashboard;
